var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconPlayCircle(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10 3.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zM2.25 10a7.75 7.75 0 1115.5 0 7.75 7.75 0 01-15.5 0z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "none", stroke: "currentColor", strokeWidth: "1.5", d: "M12.6 9.78c.18.1.18.34 0 .44l-3.98 2.27a.25.25 0 01-.37-.21V7.72c0-.19.2-.3.37-.21l3.99 2.27z" })));
}
export default IconPlayCircle;
